// extracted by mini-css-extract-plugin
module.exports =  {"tableWrapper":"lt_au0zjC5vNgsxAGgKn"};